const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL

// this should be getting account, account carriers, and account product settings 
// may want to also look at adding like an 'overlay gif' to show loading while the call is being made ? 
function retrieveAccount(utmData){
    let currentDomain = window && window.location && window.location.hostname;
    const currentPath = window && window.location.pathname === "/" ? "/home" : window && window.location.pathname;

    // set from env files based on enviorment 
    const isDev = (window.__ENV__.REACT_APP_IS_DEV_ENVIRONMENT === 'true')
    
    // check for query string override 
    if (isDev){
        const domainOverride = getAccountDomainOverrideFromQueryString()

        if(domainOverride)
            currentDomain = domainOverride
    }

    const utmQueryString = `&UtmData=${utmData}`;

    const x = fetch(`${covrServicesUrl}/api/Account?Domain=${currentDomain}&LandingPage=${currentPath}${utmData !== "[]" ? utmQueryString : ""}`, {
        method: 'GET',
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
          },
    })
    .then(x => x.json())

    return x
}

export { retrieveAccount }

const getAccountDomainOverrideFromQueryString = () => {
    const key = 'domain'  
    return decodeURIComponent(window.location.search.replace(new RegExp(`^(?:.*[&\\?]${encodeURIComponent(key).replace(/[.+*]/g, "\\$&")}(?:\\=([^&]*))?)?.*$`, "i"), "$1"));  
}  